import React from 'react'
import { Box, Button, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Alert } from '@material-ui/lab'

const useStyles = makeStyles((theme) => ({
    paper: {
        background: '#fff',
        marginBottom: 20,
        padding: theme.spacing(2),
        flexGrow: 1,
    },
    qrImage: {
        width: 200,
        height: 200,
        margin: '16px auto',
        display: 'block',
        borderRadius: 8,
    },
    zelleLogoImage: {
        width: 120,
        height: 'auto',
        margin: '8px auto 0',
        display: 'block',
    },
    zelleLogo: { fontSize: 24, fontWeight: 700, color: '#6d1ed4' },
    accountNumberRow: {
        marginBottom: theme.spacing(2),
    },
    accountNumberValue: {
        fontWeight: 700,
        textDecoration: 'underline',
        textUnderlineOffset: 3,
        fontSize: '1.125rem',
        letterSpacing: '0.06em',
        marginLeft: theme.spacing(0.5),
    },
}))

export default function ZelleDepositInstructionsPanel({
    t,
    accountId8,
    onClose,
    billingError,
    noPaper,
    hideCloseButton,
}) {
    const classes = useStyles()
    const inner = (
        <>
            {billingError && (
                <Alert severity="error" style={{ marginBottom: 16 }}>
                    {billingError}
                </Alert>
            )}
            <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
                <span className={classes.zelleLogo}>Zelle</span>
            </Box>
            <Typography variant="body1" style={{ marginBottom: 16 }}>
                {t('add_money.zelle_complete_intro')}
            </Typography>
            <Typography variant="body2" component="ol" style={{ paddingLeft: 20, marginBottom: 16 }}>
                <li dangerouslySetInnerHTML={{ __html: t('add_money.zelle_complete_step1') }} />
                <li dangerouslySetInnerHTML={{ __html: t('add_money.zelle_complete_step2') }} />
                <li>{t('add_money.zelle_complete_step3')}</li>
                <li>{t('add_money.zelle_complete_step4')}</li>
                <li>{t('add_money.zelle_complete_step5')}</li>
                <li>{t('add_money.zelle_complete_step6')}</li>
            </Typography>
            <Box textAlign="center" mb={2}>
                <Typography variant="subtitle1" color="textSecondary" style={{ marginBottom: 2 }}>
                    {t('add_money.zelle_scan_to_pay')}
                </Typography>
                <Typography variant="h5">{t('add_money.zelle_complete_recipient')}</Typography>
                <img src="/zelle-qr.png" alt="Zelle QR code" className={classes.qrImage} />
                <img src="/zelle-logo.png" alt="Zelle logo" className={classes.zelleLogoImage} />
            </Box>
            <Typography variant="body1" component="div" className={classes.accountNumberRow}>
                {t('add_money.zelle_account_number_label')}{' '}
                <Box component="span" className={classes.accountNumberValue}>
                    {accountId8}
                </Box>
            </Typography>
            {!hideCloseButton && (
                <Button variant="contained" color="primary" fullWidth onClick={onClose}>
                    {t('add_money.zelle_instructions_close')}
                </Button>
            )}
        </>
    )

    if (noPaper) {
        return <Box>{inner}</Box>
    }
    return <Paper classes={{ root: classes.paper }}>{inner}</Paper>
}
